/**
 * Layout component that queries for data
 * with Gatsby's StaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/static-query/
 */

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import ReactGA from 'react-ga';
import { graphql, useStaticQuery } from 'gatsby';

import { LiveTicker } from './LiveTicker';
import { Header } from './header';
import { Footer } from './footer';
import { BlogHeader } from './BlogHeader';
import './layout.css';

const Content = styled.div`
  margin: 0 auto;
  padding-bottom: 90px;
`;

ReactGA.initialize(process.env.GOOGLE_ANALYTICS_TRACKING_ID);
function Layout({ headerColor, headerCtaLabel, children, ...restProps }) {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `);

  console.log('index', restProps);

  const pathname = restProps.path;

  // const path = restProps.location.pathname;

  console.log('pathname here', pathname);
  ReactGA.pageview(pathname);


  return (
    <div>
      <LiveTicker />
      <Header
        headerColor={headerColor}
        ctaLabel={headerCtaLabel}
        siteTitle={data.site.siteMetadata.title}
      />
      <Content>
        <main>{children}</main>
      </Content>
      <Footer />
    </div>
  );
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
